import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import AmMicroChart from '../../../amCharts/AmMicroChart';
import NewsCardComponent from './newsCard/newsCard';
import * as AnalyticsUtil from '../../../../common/AnalyticsSvc';
import * as Const from '../../../../common/const';
import * as Utils from '../../../../common/utilSvc';
import * as CoreUtils from '../../../../common/coreHelper';
import LockIcon from '@material-ui/icons/Lock';
import ArrowDropDownCircleIcon from '@material-ui/icons/ArrowDropDownCircle';
import ArrowDropUp from '@material-ui/icons/ArrowDropUp';
import Loader from 'react-loader-spinner';
import { isNullOrUndefined, isUndefined } from "util";
import './generalData.css';
import { Grid } from '@material-ui/core';
import TechStackCardComponent from './techStack/techStackCard';
import TechStackSearchFilter from './techStack/techStackSearch';

class GeneralDataComponent extends React.Component {
    
    constructor(props){

        super(props);
        //generalData, getCompanyMission, generalFilters, userId, isLoading

        this.state = {
            searchKeys: {
                websiteTechStack: ''
            },
            newsDropState: {}
        }

        this.changeSearchKey = this.changeSearchKey.bind(this);
        this.canRenderFinancialData = this.canRenderFinancialData.bind(this);
        this.renderFinancialData = this.renderFinancialData.bind(this);
        this.canRenderKeyFacts = this.canRenderKeyFacts.bind(this);
        this.isKeyFactsLoading = this.isKeyFactsLoading.bind(this);
        this.renderKeyFacts = this.renderKeyFacts.bind(this);
        this.canRenderSummary = this.canRenderSummary.bind(this);
        this.isMissionLoading = this.isMissionLoading.bind(this);
        this.renderSummaryFull = this.renderSummaryFull.bind(this);
        this.canRenderNews = this.canRenderNews.bind(this);
        this.isNewsLoading = this.isNewsLoading.bind(this);
        this.renderNews = this.renderNews.bind(this);
        this.canRenderCyberNews = this.canRenderCyberNews.bind(this);
        this.renderSingleCyberNews = this.renderSingleCyberNews.bind(this);
        this.renderSingleCyberNewsV3 = this.renderSingleCyberNewsV3.bind(this);
        this.isCompanyCyberNewsLoading = this.isCompanyCyberNewsLoading.bind(this);
        this.canRenderIndustryCyberNews = this.canRenderIndustryCyberNews.bind(this);
        this.canRenderIndustryCyberNewsV2 = this.canRenderIndustryCyberNewsV2.bind(this);
        this.isIndustryCyberNewsLoading = this.isIndustryCyberNewsLoading.bind(this);
        this.isIndustryCyberNewsLoadingV2 = this.isIndustryCyberNewsLoadingV2.bind(this);
        this.canRenderTenKCyber = this.canRenderTenKCyber.bind(this);
        this.isTenKCyberLoading = this.isTenKCyberLoading.bind(this);
        this.renderTenKCyber = this.renderTenKCyber.bind(this);
        this.renderSecCyberSingleYear = this.renderSecCyberSingleYear.bind(this);
        this.canRenderWebsiteTechStack = this.canRenderWebsiteTechStack.bind(this);
        this.renderWebsiteTechStack = this.renderWebsiteTechStack.bind(this);
        this.renderLock = this.renderLock.bind(this);
        this.renderLoading = this.renderLoading.bind(this);
        this.renderLoadingOrNoData = this.renderLoadingOrNoData.bind(this);

        this.getCompanyMission = this.getCompanyMission.bind(this);
        this.renderIncomeStatement = this.renderIncomeStatement.bind(this);
        this.renderTestLayout = this.renderTestLayout.bind(this);
        this.dropDownNewsToggle = this.dropDownNewsToggle.bind(this);
    
    }

    changeSearchKey(key, val){
        let searchKeys = this.state.searchKeys;
        searchKeys[key] = val;
        this.setState({
            searchKeys: searchKeys
        })
    }

    getCompanyMission(){
        this.props.getCompanyMission();
    }

    canRenderFinancialData(){
        if(!isNullOrUndefined(this.props.generalData) && 
        ('incomeStatement' in this.props.generalData || 
        !isNullOrUndefined(this.props.generalData.funding))){
            return true;
        }
        return false;
    }

    renderFinancialData(){
        let incomeStatement = null;
        if('incomeStatement' in this.props.generalData){
            incomeStatement = this.props.generalData.incomeStatement;
            // console.log(incomeStatement);
        }

        let fundingNewsArr = [];
        if(!isNullOrUndefined(this.props.generalData.funding)){
            for(let i=0; i<this.props.generalData.funding.length && i<Const.maxFundingNewsArticles; i++){
                fundingNewsArr.push(this.props.generalData.funding[i]);
            }
        }
        let renderFundingNews = null;
        // console.log(fundingNewsArr);

        renderFundingNews = fundingNewsArr.map((news) => {
            return (
                <div style = {{margin:'0'}}>
                    <div onClick = {() => { AnalyticsUtil.generalDataSourceClick(news.link, 'financial_data',['funding_news'])}}>
                        <NewsCardComponent
                            date = {news.date}
                            link = {news.link}
                            source = {news.source}
                            title = {news.title}
                            snippet = {news.snippet}
                        />
                    </div>
                </div>
            )
        })

        return (
            <div>
                <h3 className="generalData-subHeader">{Const.filterData['Financial Details'].name}</h3>
                {this.props.userId && this.props.userId.length>0?
                    <div className="generalDataTileBodyContainer expand-height">
                        {!isNullOrUndefined(incomeStatement)?
                            <Paper variant="outlined" className="financialStatementsContainer" 
                                onMouseEnter={() => {AnalyticsUtil.hoverOverDiv('income_statement', true)}}
                                onMouseLeave={() => {AnalyticsUtil.hoverOverDiv('income_statement', false)}}>
                                <p style={{marginBottom:'0',marginLeft:'10px', marginRight:'10px'}}>
                                    <span style={{fontWeight:'bold', fontSize:'14px'}}>Income statement  (in $ thousands)  </span>
                                    <a href={incomeStatement.link} target="_blank" className="wikiItem-link"
                                    onClick={() => {
                                        // console.log('here');
                                        AnalyticsUtil.generalDataSourceClick(incomeStatement.link,'financial_data',['income_statement'])
                                    }}
                                    >(Source)</a>
                                </p>
                                {this.renderIncomeStatement(incomeStatement.data)}
                            </Paper>
                            :
                            null
                        }
                        {fundingNewsArr.length>0?
                            <div className="financialStatementsContainer" 
                                onMouseEnter={() => {AnalyticsUtil.hoverOverDiv('funding_news', true)}}
                                onMouseLeave={() => {AnalyticsUtil.hoverOverDiv('funding_news', false)}}>
                                {renderFundingNews}
                            </div>
                            :
                            null
                        }
                    </div>
                    :
                    this.renderLock()
                    }
            </div>
        )
    }

    renderIncomeStatement(incomeStatement){
        // console.log(incomeStatement);

        //get charts here
        let chartData = [];
        let fields = Const.yahooFields;
        let fieldsContained = {};

        for(let yearKey in incomeStatement){
            let chartEntry = {
                "date": yearKey
            }
            let currentStatement = incomeStatement[yearKey]
            // console.log(yearKey, currentStatement);
            for(let iterator in fields){
                let valKey = fields[iterator];
                // console.log(valKey, currentStatement[valKey]);
                if(!isNullOrUndefined(currentStatement[valKey]) 
                && !isNaN(Number(currentStatement[valKey].replaceAll(",","")))){
                    chartEntry[valKey] = Number(currentStatement[valKey].replaceAll(",",""));
                    fieldsContained[valKey] = "";
                }
            }
            chartData.push(chartEntry);
        }
        let newChartData = [];
        //reverse
        for(let i=chartData.length - 1; i>=0; i--){
            newChartData.push(chartData[i]);
        }
        chartData = newChartData;
        // console.log(chartData);

        let renderCharts = null;
        let amChartFieldsColors = Const.amChartFieldsColors;
        renderCharts = Object.keys(fieldsContained).map((val) => {
            // console.log(val);
            let highColor = null;
            let lowColor = null;
            
            if(val in amChartFieldsColors){
                highColor = amChartFieldsColors[val].high;
                lowColor = amChartFieldsColors[val].low;
            }
            return (
                <Grid item lg={4} md={6} sm={6} xs={6}>
                    <Paper variant="outlined">
                        <AmMicroChart
                            title={val}
                            id = {String(val)}
                            yAxis = {val}
                            xAxis = {"date"}
                            data = {chartData}
                            highColor = {highColor}
                            lowColor = {lowColor}
                            amCharts = {this.props.amCharts}
                            setAmChart = {this.props.setAmChart}
                            />
                    </Paper>
                </Grid>
            )
        })
            //{renderIS} Old
        return (
            <div style={{padding:'15px 5px 15px 5px', overflow:'hidden'}}>
                <Grid container spacing={2}>
                    {renderCharts}
                </Grid>
            </div>
        )
    }

    renderTestLayout(){
        return (
            <div>
                <Grid container spacing={1}>
                    <Grid item sm={4} xs={12}>
                        <Paper elevation={0} square className="generalDataTileContainer">
                            <p>Hi this is good <br/><br/><br/><br/><br/><br/><br/><br/><br/> I love you</p>
                        </Paper>
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <Paper elevation={0} square className="generalDataTileContainer">
                            <p>Hi this is good</p>
                        </Paper>
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <Paper elevation={0} square className="generalDataTileContainer">
                            <p>Hi this is good <br/><br/><br/><br/><br/> I love you</p>
                        </Paper>
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <Paper elevation={0} square className="generalDataTileContainer">
                            <p>Hi this is good</p>
                        </Paper>
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <Paper elevation={0} square className="generalDataTileContainer">
                            <p>Hi this is good <br/><br/>I love you</p>
                        </Paper>
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <Paper elevation={0} square className="generalDataTileContainer">
                            <p>Hi this is good</p>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        )
    }

    canRenderSummary(){
        if(!isNullOrUndefined(this.props.generalData) && 
        (('summaryText' in this.props.generalData) || ('companyMission' in this.props.generalData))){
            return true;
        }
        return false;
    }

    isMissionLoading(){
        if(!isNullOrUndefined(this.props.isLoading) && (this.props.isLoading['companyMission']))
            return true;
        return false;
    }

    renderSummaryFull(){
        //Renders wikisummary and mission statement

        let summaryText = null, companyMission = null;
        if('summaryText' in this.props.generalData)
            summaryText = this.props.generalData['summaryText'];
        if('companyMission' in this.props.generalData){
            companyMission  = this.props.generalData.companyMission;
            //title and link
        }
        return (
            <div>
                <h3 className="generalData-subHeader">{Const.filterData['Summary'].name}</h3>
                <div className="generalDataTileBodyContainer expand-height"
                    onMouseEnter={() => {AnalyticsUtil.hoverOverDiv('general_summary', true)}}
                    onMouseLeave={() => {AnalyticsUtil.hoverOverDiv('general_summary', false)}}>
                        <Paper variant="outlined" className="generalWikiContainerPaper" 
                         square>
                             {!isNullOrUndefined(this.props.generalData) && !isNullOrUndefined(this.props.generalData.imageLogo)?
                                        <div style={{textAlign:'center',margin:'auto'}}>
                                                <img 
                                                // src="//upload.wikimedia.org/wikipedia/commons/thumb/8/80/Roblox_Logo_Black.svg/220px-Roblox_Logo_Black.svg.png"
                                                src={this.props.generalData.imageLogo.url}
                                                style={{maxHeight:'10vh', border:'0.5px darkgrey solid', padding:'0.5em'}}>                    
                                                </img>
                                        </div>
                                        :
                                        null
                                }
                            <ul className="summaryListContainer">
                        {!isNullOrUndefined(summaryText)?
                            <li>
                                <p className="summaryTextValue">
                                {summaryText.data}  
                                <span className="summaryTextSource">
                                    <a target="_blank" href={summaryText.link}
                                    onClick = {() => { AnalyticsUtil.generalDataSourceClick(summaryText.link, 'general_summary',['about_company'])}}>
                                        (Source)
                                    </a>
                                </span>
                            </p>
                            </li>
                            :
                            null
                        }

                        {!isNullOrUndefined(companyMission)?
                            <li>
                                <p className="companyMission-snippet">
                                    <span style={{fontWeight:'900'}}>Mission: </span>{companyMission.snippet}
                                    {!isNullOrUndefined(companyMission.link)?                    
                                        <span className="companyMission-link"> <a href={this.props.generalData.companyMission.link} target="_blank"
                                        onClick = {() => { AnalyticsUtil.generalDataSourceClick(companyMission.link, 'general_summary',['company_mission'])}}>{companyMission.title}</a></span>
                                        :
                                        null
                                    }
                                </p>
                            </li>
                            :
                            null
                        }


                    </ul>
                        </Paper>
                </div>
            </div>
        )
    }

    renderSummaryAndKeyFacts(){
        let summaryText = null, companyMission = null;
        if('summaryText' in this.props.generalData)
            summaryText = this.props.generalData['summaryText'];
        if('companyMission' in this.props.generalData){
            companyMission  = this.props.generalData.companyMission;
            //title and link
        }
        let generalWikiData = Const.displaySummaryData;
        let renderArr = [];
        for(let i=0; i<generalWikiData.length && !isNullOrUndefined(this.props.generalData);i++){
            // console.log(this.props.generalData);
            if(generalWikiData[i] in this.props.generalData){
                renderArr.push({
                    'key': generalWikiData[i],
                    'val': this.props.generalData[generalWikiData[i]].data,
                    'link': this.props.generalData[generalWikiData[i]].link
                })

                if(renderArr[renderArr.length-1].key!='website'){
                    renderArr[renderArr.length-1].val = Utils.capitalizeFirstLetter(String(renderArr[renderArr.length-1].val))
                }
                else{
                    let websiteLink = renderArr[renderArr.length-1].val
                    if(!websiteLink.includes('https://') && !websiteLink.includes('http://')){
                        renderArr[renderArr.length-1].val = "https://" + renderArr[renderArr.length-1].val;
                    }
                }
            }
        }
        // console.log(renderArr);

        const renderlistItems = renderArr.map((data) =>
             <p>
                 <span className="wikiItem-key">{Utils.capitalizeFirstLetter(data.key)}: </span>
                {data.key == 'website'?
                    <a className="wikiItem-val" href={data.val} target="_blank"
                    onClick = {() => { AnalyticsUtil.generalDataSourceClick(data.val, 'key_facts', ['website_link'])}}>{data.val}</a>
                    :
                    null
                }
                {data.key != 'website'?
                    <span className="wikiItem-val">{!isNullOrUndefined(data.val) && data.val.toLowerCase()!='undefined'?data.val:null}</span>
                    :
                    null
                }
                <span> <a href={data.link} target="_blank" className="wikiItem-link"
                onClick = {() => { AnalyticsUtil.generalDataSourceClick(data.link, 'key_facts', [data.key])}}>(Source)</a></span>
            </p>
        );
        return (
            <div>
                <h3 className="generalData-subHeader">{Const.filterData['About'].name}</h3>
                <div className="generalDataTileBodyContainer expand-height"
                    onMouseEnter={() => {AnalyticsUtil.hoverOverDiv('general_summary', true)}}
                    onMouseLeave={() => {AnalyticsUtil.hoverOverDiv('general_summary', false)}}>
                        <Paper variant="outlined" className="generalWikiContainerPaper" 
                         square>
                              {!isNullOrUndefined(this.props.generalData) && !isNullOrUndefined(this.props.generalData.imageLogo)?
                                        <div style={{textAlign:'center',margin:'auto'}}>
                                                <img 
                                                // src="//upload.wikimedia.org/wikipedia/commons/thumb/8/80/Roblox_Logo_Black.svg/220px-Roblox_Logo_Black.svg.png"
                                                src={this.props.generalData.imageLogo.url}
                                                style={{maxHeight:'10vh', border:'0.5px darkgrey solid', padding:'0.5em'}}>                    
                                                </img>
                                        </div>
                                        :
                                        null
                                }
                             {this.canRenderSummary()?
                                <div>
                                    <div className="summaryListContainer">
                                        {!isNullOrUndefined(summaryText)?
                                                <p className="summaryTextValue">
                                                {summaryText.data}  
                                                <span className="summaryTextSource">
                                                    <a target="_blank" href={summaryText.link}
                                                    onClick = {() => { AnalyticsUtil.generalDataSourceClick(summaryText.link, 'general_summary',['about_company'])}}>
                                                        (Source)
                                                    </a>
                                                </span>
                                            </p>
                                            :
                                            null
                                        }

                                        {!isNullOrUndefined(companyMission)?
                                                <p className="companyMission-snippet">
                                                    <span style={{fontWeight:'900'}}>Mission: </span>{companyMission.snippet}
                                                    {!isNullOrUndefined(companyMission.link)?                    
                                                        <span className="companyMission-link"> <a href={this.props.generalData.companyMission.link} target="_blank"
                                                        onClick = {() => { AnalyticsUtil.generalDataSourceClick(companyMission.link, 'general_summary',['company_mission'])}}>{companyMission.title}</a></span>
                                                        :
                                                        null
                                                    }
                                                </p>
                                            :
                                            null
                                        }


                                    </div>
                                </div>
                                :
                                null
                             }
                             {this.canRenderKeyFacts()?
                                <div className="generalWikiContainer">
                                    {renderlistItems}
                                </div>
                                :
                                null
                             }
                             
                        </Paper>
                </div>
            </div>
        )
    }
    
    canRenderTenKCyber(){
        if(isNullOrUndefined(this.props.generalData))
            return false;
        if(!('tenK_cyber' in this.props.generalData)){
            return false;
        }
        return true;
    }

    isTenKCyberLoading(){
        if(!isNullOrUndefined(this.props.isLoading) && this.props.isLoading['tenK_cyber']){
            return true;
        }
        return false;
    }

    renderSecCyberSingleYear(secElement, type){
        if(isNullOrUndefined(secElement))
            return null;
        
        let data = secElement['data'];
        let dateTime = secElement['ts_string'];

        let textStrings = null;
        textStrings = data.map((element) => {
            let text = element.text;

            return (
                <li className="secCyberElementListText">
                    {text}
                </li>
            )
        });

        return (
            <li className="secCyberElementContainer">
                <p className="secCyberElementHeader">{type} ({dateTime}):</p>
                <ul className="secCyberElementListTextContainer">
                    {textStrings}
                </ul>
            </li>
        )
    }

    renderTenKCyber(){
        let tenKArr = this.props.generalData['tenK_cyber'];

        let tenKRender = null;
        let scope = this;

        tenKRender = tenKArr.map((secElement) => {
            return scope.renderSecCyberSingleYear(secElement,'10-K');
        })

        return (
            <div>
                <h3 className="generalData-subHeader">{Const.filterData['tenK_cyber'].name}</h3>
                <p className="generalData-subHeader-subtitle">{Const.filterData['tenK_cyber'].subtitle}</p>


                {this.props.userId && this.props.userId.length>0?
                <Paper elevation={0} variant="outlined">
                    <div className="generalDataTileBodyContainer"
                        onMouseEnter={() => {AnalyticsUtil.hoverOverDiv('tenK_cyber', true)}}
                        onMouseLeave={() => {AnalyticsUtil.hoverOverDiv('tenK_cyber', false)}}>
                        
                            <div className="secCyberMainContainer">
                                <ul className="secCyberMainListContainer">
                                    {tenKRender}
                                </ul>
                            </div>                                       
                    </div>
                </Paper>   
                :
                scope.renderLock()
                }
            </div>
        )
    }

    renderLoading(loadingPane){
        return (
            <div>
                <h3 className="generalData-subHeader">{Const.filterData[loadingPane].name}</h3>
                {'subtitle' in Const.filterData[loadingPane]?
                    <p className="generalData-subHeader-subtitle">{Const.filterData[loadingPane].subtitle}</p>
                    :
                    null
                }
                <div>
                    <div style={{margin:'auto',width:'50px'}}>
                        <Loader 
                        type="TailSpin"
                        color="#00BFFF"
                        height="50"	
                        width="50"
                        /> 
                    </div>
                </div>
            </div>
        )

    }

    renderLock(){
        return (
            <Paper elevation={0} variant="outlined">
                <div className="generalDataTileBodyLocked">
                    <p style={{marginBottom:'10px'}}>
                        Enter email to unlock additional content.
                    </p>
                    <div><LockIcon /></div>
                </div>
            </Paper>
        )
    }

    canRenderKeyFacts(){
        if(isNullOrUndefined(this.props.generalData))
            return false;

        let canRenderKeyFacts = false;
        let generalWikiData = Const.generalWikiData;
        for(let i=0; i<generalWikiData.length; i++){
            if(generalWikiData[i] in this.props.generalData)
            {
                canRenderKeyFacts = true;
                break;
            }
        }
        return canRenderKeyFacts;
    }

    isKeyFactsLoading(){
        if(!isNullOrUndefined(this.props.isLoading) && (this.props.isLoading['google-search'] || this.props.isLoading['wiki-data']))
            return true;
        return false;
    }

    renderKeyFacts(){
        let generalWikiData = Const.displaySummaryData;
        let renderArr = [];
        for(let i=0; i<generalWikiData.length && !isNullOrUndefined(this.props.generalData);i++){
            // console.log(this.props.generalData);
            if(generalWikiData[i] in this.props.generalData){
                renderArr.push({
                    'key': generalWikiData[i],
                    'val': this.props.generalData[generalWikiData[i]].data,
                    'link': this.props.generalData[generalWikiData[i]].link
                })

                if(renderArr[renderArr.length-1].key!='website'){
                    renderArr[renderArr.length-1].val = Utils.capitalizeFirstLetter(String(renderArr[renderArr.length-1].val))
                }
                else{
                    let websiteLink = renderArr[renderArr.length-1].val
                    if(!websiteLink.includes('https://') && !websiteLink.includes('http://')){
                        renderArr[renderArr.length-1].val = "https://" + renderArr[renderArr.length-1].val;
                    }
                }
            }
        }
        // console.log(renderArr);

        const renderlistItems = renderArr.map((data) =>
             <p>
                 <span className="wikiItem-key">{Utils.capitalizeFirstLetter(data.key)}: </span>
                {data.key == 'website'?
                    <a className="wikiItem-val" href={data.val} target="_blank"
                    onClick = {() => { AnalyticsUtil.generalDataSourceClick(data.val, 'key_facts', ['website_link'])}}>{data.val}</a>
                    :
                    null
                }
                {data.key != 'website'?
                    <span className="wikiItem-val">{!isNullOrUndefined(data.val) && data.val.toLowerCase()!='undefined'?data.val:null}</span>
                    :
                    null
                }
                <span> <a href={data.link} target="_blank" className="wikiItem-link"
                onClick = {() => { AnalyticsUtil.generalDataSourceClick(data.link, 'key_facts', [data.key])}}>(Source)</a></span>
            </p>
        );

        return (
            <div>
                <h3 className="generalData-subHeader">{Const.filterData['Key Facts'].name}</h3>
                <div className="generalDataTileBodyContainer expand-height"
                    onMouseEnter={() => {AnalyticsUtil.hoverOverDiv('key_facts', true)}}
                    onMouseLeave={() => {AnalyticsUtil.hoverOverDiv('key_facts', false)}}>
                    <div className="generalWikiContainer">
                        <Paper variant="outlined" className="generalWikiContainerPaper" 
                         square>
                            {renderlistItems}
                        </Paper>
                    </div>
                </div>
            </div>

        )
    }

    canRenderNews(){
        if(!isNullOrUndefined(this.props.generalData) && 'companyNews' in this.props.generalData && this.props.generalData['companyNews'].length>0){
            return true;
        }
        return false;
    }

    isNewsLoading(){
        if(!isNullOrUndefined(this.props.isLoading) && (this.props.isLoading['company_google_news']))
            return true;
        return false;
    }

    renderNews(){
        let companyNews = this.props.generalData['companyNews'];
        // console.log(companyNews);

        let renderNews = null;
        renderNews = companyNews.map((news) => {
            return (
                <div style = {{margin:'0 5px 5px 5px'}}>
                    <div onClick = {() => { AnalyticsUtil.generalDataSourceClick(news.link, 'general_news')}}>
                        <NewsCardComponent
                            date = {news.date}
                            link = {news.link}
                            source = {news.source}
                            title = {news.title}
                            snippet = {news.snippet}
                        />
                    </div>
                </div>
            )
        })
        return (
            <div>
                <h3 className="generalData-subHeader">{Const.filterData['News'].name}</h3>
                {this.props.userId && this.props.userId.length>0?
                    <div className="generalDataTileBodyContainer expand-height"
                        onMouseEnter={() => {AnalyticsUtil.hoverOverDiv('general_news', true)}}
                        onMouseLeave={() => {AnalyticsUtil.hoverOverDiv('general_news', false)}}>
                        {renderNews}
                    </div>
                    :
                    this.renderLock()
                }

            </div>
        )
    }

    canRenderWebsiteTechStack(){
        if(!isNullOrUndefined(this.props.generalData) && 'websiteTechStack' in this.props.generalData && this.props.generalData['websiteTechStack'].length>0){
            return true;
        }
        return false;
    }

    renderWebsiteTechStack(){
        let websiteTechStack = this.props.generalData['websiteTechStack'];
        // console.log(companyNews);

        websiteTechStack = CoreUtils.getTechStackListBasedOnKeyWord(websiteTechStack, this.state.searchKeys.websiteTechStack);

        let renderWebsiteTechStack = null;
        renderWebsiteTechStack = websiteTechStack.map((techStack) => {
            return (
                <div style = {{margin:'0 5px 5px 5px'}}>
                    <div>
                        <TechStackCardComponent
                            techStack = {techStack}
                        />
                    </div>
                </div>
            )
        })
        return (
            <div>
                <h3 className="generalData-subHeader">{Const.filterData['websiteTechStack'].name}</h3>
                {this.props.userId && this.props.userId.length>0?
                    <div className="generalDataTileBodyContainer expand-height"
                        onMouseEnter={() => {AnalyticsUtil.hoverOverDiv('website_tech_stack', true)}}
                        onMouseLeave={() => {AnalyticsUtil.hoverOverDiv('website_tech_stack', false)}}>
                        <div>
                            <TechStackSearchFilter
                                handleTechStackKeyChange = {this.changeSearchKey}
                                techStackKeyName = {'websiteTechStack'}
                                techStackKey = {this.state.searchKeys.websiteTechStack}
                                />
                        </div>
                        <div className="maxHeight-500">
                            {renderWebsiteTechStack}
                        </div>
                    </div>
                    :
                    this.renderLock()
                }

            </div>
        )
    }

    canRenderCyberNews(){
        if(!isNullOrUndefined(this.props.generalData) && 'cyberNews' in this.props.generalData && Object.keys(this.props.generalData.cyberNews).length>0)
            return true;
        return false;
    }

    isCompanyCyberNewsLoading(){
        if(!isNullOrUndefined(this.props.isLoading) && (this.props.isLoading['cyberNews']))
            return true;
        return false;
    }

    renderSingleCyberNewsV2(cyberNewsKey, cyberNewsArr){
        if(isNullOrUndefined(cyberNewsKey) || isNullOrUndefined(cyberNewsArr))
            return null;

        // console.log(cyberNewsArr);
        let cyberNewsArrDateSorted = CoreUtils.sortBasedOnDate(cyberNewsArr,'date');

        let renderNews = null;
        let scope = this;
        renderNews = cyberNewsArrDateSorted.map((news) => {

            return (
                <li style = {{margin:'0 5px 10px 5px'}}>
                    <div onClick = {() => { AnalyticsUtil.generalDataSourceClick(news.link, cyberNewsKey)}}>
                        <p>
                            <span style={{fontWeight:600}}>{news.title} </span>
                            <a href={news.link} target="_blank">({news.date})</a>
                        </p>
                    </div>
                </li>
            )
        })

        return (
            <div>
                <h3 className="generalData-subHeader">{Const.filterData[cyberNewsKey].name}</h3>
                {'subtitle' in Const.filterData[cyberNewsKey]?
                    <p className="generalData-subHeader-subtitle">{Const.filterData[cyberNewsKey].subtitle}</p>
                    :
                    null
                }
                <div className="generalDataTileBodyContainer generalDataCyberNewsBodyContainer"
                    onMouseEnter={() => {AnalyticsUtil.hoverOverDiv(cyberNewsKey, true)}}
                    onMouseLeave={() => {AnalyticsUtil.hoverOverDiv(cyberNewsKey, false)}}>
                    {(scope.props.userId && scope.props.userId.length>0) || (cyberNewsKey != 'cyberIndustryNews' && cyberNewsKey != 'cyberIndustryNewsV2')?
                        <Paper elevation={0} variant="outlined" className="cyberNewsV2_Container maxHeight-350">
                            <ul className="cyberNewsV2_ListContainer">
                                {renderNews}
                            </ul>
                        </Paper>:
                        this.renderLock()
                    }
                </div>
            </div>
        )
        
    }

    dropDownNewsToggle(newsLink){
        let newsDropState = this.state.newsDropState;
        if(newsLink in newsDropState){
            delete newsDropState[newsLink];
        }
        else{
            newsDropState[newsLink] = true;

            //Analytics here
            let newProp = {};
            if(this.props.userId){
                newProp['userId']=this.props.userId;
            }
            AnalyticsUtil.summaryOpen(newsLink,newProp)
        }
        this.setState({newsDropState: newsDropState});
    }

    renderSingleCyberNewsV3(cyberNewsKey, cyberNewsArr){
        if(isNullOrUndefined(cyberNewsKey) || isNullOrUndefined(cyberNewsArr))
            return null;

        // console.log(cyberNewsArr);
        let cyberNewsArrDateSorted = CoreUtils.sortBasedOnDate(cyberNewsArr,'date');

        let renderNews = null;
        let scope = this;
        let newsDropState = this.state.newsDropState;
        let newsSummaries = this.props.newsSummaries;
        renderNews = cyberNewsArrDateSorted.map((news) => {

            let summaryRender = null;

            let isNewsExist = false;
            if(news.link in newsSummaries)
                isNewsExist = true;
            if(isNewsExist){
                summaryRender = newsSummaries[news.link].map((sentence) => {
                    return (
                        <li style = {{margin:'0 3px 6px 3px'}}>
                            <p>{sentence}</p>
                        </li>
                    )
                })
            }

            let isDroppedDown = false;
            if(news.link in newsDropState)
                isDroppedDown = true;

            return (
                <div style = {{margin:'0 5px 10px 5px'}}>
                    <div>
                        <div style={{display:'flex', flexWrap:'wrap'}}>
                            {isNewsExist?
                                <div style={{width:'10%', paddingTop:'15px', float:'left'}}>
                                    {isDroppedDown?
                                        <ArrowDropUp className="dropDownIcon" onClick={() => scope.dropDownNewsToggle(news.link)}/>
                                        :
                                        <ArrowDropDownCircleIcon className="dropDownIcon" onClick={() => scope.dropDownNewsToggle(news.link)}/>
                                    }
                                </div>                           
                                :
                                null
                            } 
                            <div className={isNewsExist? 'width-pc-85': ''} onClick = {() => { AnalyticsUtil.generalDataSourceClick(news.link, cyberNewsKey)}}>
                                <p>         
                                    <span style={{fontWeight:600}}>{news.title} </span>
                                    <a href={news.link} target="_blank">({news.date})</a>
                                </p>
                            </div>                            
                        </div>
                        {isNewsExist && isDroppedDown?
                            <ul>
                                {summaryRender}
                            </ul>
                            :
                            null
                        }
                    </div>
                </div>
            )
        })

        return (
            <div>
                <h3 className="generalData-subHeader">{Const.filterData[cyberNewsKey].name}</h3>
                {'subtitle' in Const.filterData[cyberNewsKey]?
                    <p className="generalData-subHeader-subtitle">{Const.filterData[cyberNewsKey].subtitle}</p>
                    :
                    null
                }
                <div className="generalDataTileBodyContainer generalDataCyberNewsBodyContainer"
                    onMouseEnter={() => {AnalyticsUtil.hoverOverDiv(cyberNewsKey, true)}}
                    onMouseLeave={() => {AnalyticsUtil.hoverOverDiv(cyberNewsKey, false)}}>
                    {(scope.props.userId && scope.props.userId.length>0) || (cyberNewsKey != 'cyberIndustryNews' && cyberNewsKey != 'cyberIndustryNewsV2')?
                        <Paper elevation={0} variant="outlined" className="cyberNewsV2_Container maxHeight-350">
                            <div className="cyberNewsV3_ListContainer">
                                {renderNews}
                            </div>
                        </Paper>:
                        this.renderLock()
                    }
                </div>
            </div>
        )
        
    }


    renderSingleCyberNews(cyberNewsKey, cyberNewsArr){
        if(isNullOrUndefined(cyberNewsKey) || isNullOrUndefined(cyberNewsArr))
            return null;

        let renderNews = null;
        renderNews = cyberNewsArr.map((news) => {
            return (
                <div style = {{margin:'0 5px 5px 5px'}}>
                    <div onClick = {() => { AnalyticsUtil.generalDataSourceClick(news.link, cyberNewsKey)}}>
                        <NewsCardComponent
                            date = {news.date}
                            link = {news.link}
                            source = {news.source}
                            title = {news.title}
                            snippet = {news.snippet}
                        />
                    </div>
                </div>
            )
        })

        return (
            <div>
                <h3 className="generalData-subHeader">{Const.filterData[cyberNewsKey].name}</h3>
                <div className="generalDataTileBodyContainer"
                    onMouseEnter={() => {AnalyticsUtil.hoverOverDiv(cyberNewsKey, true)}}
                    onMouseLeave={() => {AnalyticsUtil.hoverOverDiv(cyberNewsKey, false)}}>
                    {renderNews}
                </div>
            </div>
        )
        
    }

    canRenderIndustryCyberNews(){
        if(!isNullOrUndefined(this.props.generalData) && !isNullOrUndefined(this.props.generalData['cyberIndustryNews'])){
            return true;
        }
        return false;
    }

    canRenderIndustryCyberNewsV2(){
        if(!isNullOrUndefined(this.props.generalData) && !isNullOrUndefined(this.props.generalData['cyberIndustryNewsV2'])){
            return true;
        }
        return false;
    }

    isIndustryCyberNewsLoading(){
        if(!isNullOrUndefined(this.props.isLoading) && (this.props.isLoading['cyberIndustryNews']))
            return true;
        return false;
    }

    isIndustryCyberNewsLoadingV2(){
        if(!isNullOrUndefined(this.props.isLoading) && (this.props.isLoading['cyberIndustryNewsV2']))
            return true;
        return false;
    }

    renderLoadingOrNoData(type, isLoading){
        if(isLoading){
            return (
                <Grid item lg={12} sm={12} xs={12}>
                    <Paper elevation={0} square className="generalDataTileContainer generalDataNewsTileContainer">  
                        {this.renderLoading(type)}
                    </Paper>
                </Grid>
            )
        }
        return null;
    }

    render(){
        let cyberNewsBoxes = null;
        let scope = this;
        if(this.canRenderCyberNews()){
            let cyberNews = this.props.generalData.cyberNews;
            cyberNewsBoxes = Object.keys(cyberNews).map((key,index) => {
                return (
                    <Grid item lg={12} sm={12} xs={12}>                     
                        <Paper elevation={0} square className="generalDataTileContainer">
                            {key == 'cyberIncidents'?
                                scope.renderSingleCyberNewsV3(key,CoreUtils.cyberNewsArticlesRenderFilter(cyberNews[key], CoreUtils.getKeyWords(this.props.keywordFilterCategories, Const.cyberNewsKeywordsForUI),6))
                            :
                                scope.renderSingleCyberNewsV3(key,cyberNews[key])
                        }
                        </Paper>
                    </Grid>
                )
            })
        }

        return (
            <div style={{marginLeft:'1em', background:'#f3f3f3', border:'0.5px solid grey', marginRight:'1em', padding:'1em 1em 1em 1em'}}>
                {this.props.debug?
                    <div style={{display:'flex', flexWrap:'wrap', marginBottom:'10px', marginLeft:'1em'}}>
                        <div>
                            <Button 
                                color="primary"
                                variant="contained"
                                className="genericButton_v1" 
                                onClick={() => {this.props.getAllData()}}>
                                    
                                        <div>All</div>
                            </Button>
                        </div>

                        {!('companyMission' in this.props.generalData)?
                            <div>
                                <Button 
                                    color="primary"
                                    variant="contained"
                                    className="genericButton_v1" 
                                    onClick={() => {this.props.getCompanyMission()}}>
                                        
                                            <div>Mission</div>
                                </Button>
                            </div>
                            :
                            null
                        } 
                        <div>
                            <Button 
                                color="primary"
                                variant="contained"
                                className="genericButton_v1" 
                                onClick={() => {this.props.getCompanyGoogleSearchData()}}>                               
                                        <div>Google Search</div>
                            </Button>
                        </div>   
                        <div>
                            <Button 
                                color="primary"
                                variant="contained"
                                className="genericButton_v1" 
                                onClick={() => {this.props.getCompanyGoogleNewsData()}}>                               
                                        <div>Google News</div>
                            </Button>
                        </div> 

                        {!isNullOrUndefined(this.props.generalData) && this.props.generalData.isPublic && 
                        (!isNullOrUndefined(this.props.generalData.stockTickers) && this.props.generalData.stockTickers.length>0)
                        && isNullOrUndefined(this.props.generalData.incomeStatement)?
                            <div>
                                <Button 
                                    color="primary"
                                    variant="contained"
                                    className="genericButton_v1" 
                                    onClick={() => {this.props.getPublicStockRelatedData(this.props.generalData.stockTickers)}}>                               
                                            <div>Financial statements</div>
                                </Button>
                            </div> 
                            :
                            null
                        }  

                        {!isNullOrUndefined(this.props.generalData) && this.props.generalData.isPrivate
                        && isNullOrUndefined(this.props.generalData.funding)?
                            <div>
                                <Button 
                                    color="primary"
                                    variant="contained"
                                    className="genericButton_v1" 
                                    onClick={() => {this.props.getFundingData()}}>                               
                                            <div>Funding</div>
                                </Button>
                            </div>
                            :
                            null
                        }
                    
                    </div>
                    :
                    null    
                }

                <Grid container spacing={1} style={{marginBottom:'1em'}}>
                    <Grid item lg={4} sm={6} xs={12}>
                        <Grid container spacing={1} style={{marginBottom:'1em'}}>

                            {this.canRenderKeyFacts() || this.canRenderSummary()?
                                <Grid item lg={12} sm={12} xs={12}>
                                    <Paper elevation={0} square className="generalDataTileContainer">
                                        {this.renderSummaryAndKeyFacts()}
                                    </Paper>
                                </Grid>
                                :
                                this.renderLoadingOrNoData('About',(this.isKeyFactsLoading() || this.isMissionLoading())) 
                            }

                            {this.canRenderFinancialData() && (this.props.generalFilters && this.props.generalFilters['Financial Details'])?
                                <Grid item lg={12} sm={12} xs={12}>
                                    <Paper elevation={0} className="generalDataTileContainer">
                                        {this.renderFinancialData()}
                                    </Paper>
                                </Grid>
                                :
                                null
                            }

                            

                        </Grid>
                    </Grid>
                    <Grid item lg={4} sm={6} xs={12}>
                        <Grid container spacing={1} style={{marginBottom:'1em'}}>
                            {cyberNewsBoxes}

                            {!(this.canRenderCyberNews())?
                                this.renderLoadingOrNoData('cyberIncidents',this.isCompanyCyberNewsLoading())
                                :
                                null 
                            }

                            {this.canRenderIndustryCyberNewsV2()?
                                <Grid item lg={12} sm={12} xs={12}>
                                    <Paper elevation={0} square className="generalDataTileContainer">
                                        {scope.renderSingleCyberNewsV3('cyberIndustryNewsV2', CoreUtils.cyberNewsArticlesRenderFilter(this.props.generalData['cyberIndustryNewsV2'], CoreUtils.getKeyWords(this.props.keywordFilterCategories, Const.cyberNewsKeywordsForUI),8))}
                                    </Paper>
                                </Grid>                           
                                :
                                this.renderLoadingOrNoData('cyberIndustryNewsV2',this.isIndustryCyberNewsLoadingV2())   
                            }

                            {this.canRenderIndustryCyberNews()?
                                <Grid item lg={12} sm={12} xs={12}>
                                    <Paper elevation={0} square className="generalDataTileContainer">
                                        {scope.renderSingleCyberNewsV3('cyberIndustryNews', CoreUtils.cyberNewsArticlesRenderFilter(this.props.generalData['cyberIndustryNews'], CoreUtils.getKeyWords(this.props.keywordFilterCategories, Const.cyberNewsKeywordsForUI),8))}
                                    </Paper>
                                </Grid>                           
                                :
                                this.renderLoadingOrNoData('cyberIndustryNews',this.isIndustryCyberNewsLoading())   
                            }

                            {this.canRenderWebsiteTechStack()?
                                <Grid item lg={12} sm={12} xs={12}>
                                    <Paper elevation={0} square className="generalDataTileContainer">
                                        {this.renderWebsiteTechStack()}
                                    </Paper>
                                </Grid>
                                :
                                this.renderLoadingOrNoData('websiteTechStack',this.isTenKCyberLoading())
                            }
                        </Grid>
                    </Grid>
                    <Grid item lg={4} sm={6} xs={12}>
                        <Grid container spacing={1} style={{marginBottom:'1em'}}>
                            {this.canRenderTenKCyber()?
                                <Grid item lg={12} sm={12} xs={12}>
                                    <Paper elevation={0} square className="generalDataTileContainer">
                                        {this.renderTenKCyber()}
                                    </Paper>
                                </Grid>
                                :
                                this.renderLoadingOrNoData('tenK_cyber',this.isTenKCyberLoading())
                            }
                            {this.canRenderNews() && (this.props.generalFilters && this.props.generalFilters['News'])?
                                <Grid item lg={12} sm={12} xs={12}>
                                    <Paper elevation={0} square className="generalDataTileContainer generalDataNewsTileContainer">                           
                                            {this.renderNews()}
                                    </Paper>
                                </Grid>
                                :
                                this.renderLoadingOrNoData('News',this.isNewsLoading())                               
                            }
                        </Grid>
                    </Grid>
                </Grid>                
            </div>
        )
    }
}
export default GeneralDataComponent;